import classNames from 'classnames';
import { TimePicker, TimePickerProps } from 'antd';
import dayjs from 'dayjs';
import styles from './time-picker.module.css';

const MTimePicker: React.FC<TimePickerProps> = (props) => {
  return (
    <TimePicker
      {...props}
      className={classNames(
        styles['time-picker'],
        'trojan-date-picker',
        props?.className
      )}
      defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
    />
  );
};
export default MTimePicker;
